// frontend/src/components/EnvChecker.js

import React from 'react';

const EnvChecker = () => {
  return (
    <div>
      <h2>Environment Variables</h2>
      <p>Front URL: {process.env.REACT_APP_FRONTEND_URL}</p>
      <p>API Base URL: {process.env.REACT_APP_API_BASE_URL}</p>
      <p>Socket IO URL: {process.env.REACT_APP_SOCKET_IO_URL}</p>

    </div>
  );
};

export default EnvChecker;
